
export function sortAlphaNumeric(a, b) {
    if (a === null || b === null) return null;
    const normalize = str => {
        if (str.startsWith(".")) str = str.slice(1); // Remove leading dot
        const match = str.match(/^(\d+(\.\d+)?)/); // Match leading number
        return match ? parseFloat(match[0]) : null;
    };
    const aNum = normalize(a.toString());
    const bNum = normalize(b.toString());
    const aIsNum = aNum !== null;
    const bIsNum = bNum !== null;
    // Numeric sort first if both are numbers
    if (aIsNum && bIsNum) return aNum - bNum;
    // If one is number and the other is string, keep number first
    if (aIsNum) return -1;
    if (bIsNum) return 1;
    // Otherwise sort alphabetically
    return a.toString()?.localeCompare(b.toString());
}
